// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LaborActivities_wrapper__18MR7","wrapper__button":"LaborActivities_wrapper__button__1-yzU","error":"LaborActivities_error__3V6Ag","info":"LaborActivities_info__11miE"};